import { ChangeEvent, LayoutProvidedTaskDecoratorProps, LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutCalculateEscrowInterest } from "./autogen/AutogenLayoutCalculateEscrowInterest";

const TASK_DESCRIPTION = "Calculate Escrow Interest";

export class CalculateEscrowInterest extends AutogenLayoutCalculateEscrowInterest {

  public override get taskDecoratorProps(): Partial<LayoutProvidedTaskDecoratorProps> {
            return {
                processLogDescription: TASK_DESCRIPTION
            };
        }

    onLoad(): void | Promise<void> {
        this.textboxReportType.setSelectedItemFromValue("Detailed");
        this.excludabletextboxEscrowAccounts.switchRange.addChangeListener((event: ChangeEvent) => {
            if (event.newValue) {
                this.excludabletextboxEscrowAccounts.textboxRangeEnd.addBeforeLookupModelSearchListener((event: LookupModelSearchEvent) => {
                    this.textboxEscrowAccountstextboxBeforeLookupModelSearch(event);
                });
                this.excludabletextboxEscrowAccounts.textboxRangeStart.addBeforeLookupModelSearchListener((event: LookupModelSearchEvent) => {
                    this.textboxEscrowAccountstextboxBeforeLookupModelSearch(event);
                });
            }
        });
        this.excludabletextboxPayees.switchRange.addChangeListener((event: ChangeEvent) => {
            if (event.newValue) {
                this.excludabletextboxPayees.textboxRangeEnd.addBeforeLookupModelSearchListener((event: LookupModelSearchEvent) => {
                    this.textboxBeforeLookupModelSearch(event);
                });
                this.excludabletextboxPayees.textboxRangeStart.addBeforeLookupModelSearchListener((event: LookupModelSearchEvent) => {
                    this.textboxBeforeLookupModelSearch(event);
                });
            }
        });
            
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxEscrowAccounts-textbox. */
    textboxEscrowAccountstextboxBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.isactive = "Y";
        event.filter.is_escrow = "Y";
        event.filter.esc_is_interest = "Y";
    }

    /** This is an event handler for the beforeLookupModelSearch event of excludabletextboxPayees-textbox. */
    textboxBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.non_office_emp = 'Y';
    }
}
